module.exports = __webpack_public_path__ + "img/img1.e8cbd644.png";